import Avatar from "./basic-5-avatar.jpg";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import StepsPattern from "./steps-pattern.svg";
import BaseTemplate from "../base";

class Basic5 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #5";
    this.id = "6";
    this.url = "/ai/carousels/basic-6";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Loki Bright",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@lokibright",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#5046e5",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#ffffff",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Antonio",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Karla",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Content Plan Strategy",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "72px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Paste your article",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Read an interesting article that you want to share with your LinkedIn audience?

We've got you covered. Simply copy the link and paste the link to “Article to LinkedIn post” template inside Supergrow.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Select the format",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Once you paste the link, select your preferred format.

You can select from 10+ formats available at your fingertips to help you create visually appealing LinkedIn posts.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Try it out & let us know your feedback",
            max_words: 7,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[5]?.value || "Antonio";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Karla";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        {index === carouselLength - 1 && (
          <>
            <div className="relative py-10">
              <div
                className="absolute inset-0 flex items-center"
                aria-hidden="true"
              >
                <div
                  className="w-full border-t-4"
                  style={{
                    borderColor: this.getPrimaryColor(commonSettings),
                  }}
                />
              </div>
              <div className="relative flex justify-start">
                <span
                  className="pl-10 pr-4 text-lg font-semibold"
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                    backgroundColor: this.getBackgroundColor(commonSettings),
                    fontFamily: this.getPrimaryFont(commonSettings),
                  }}
                >
                  {<TextView text={commonSettings.elements[2]?.value} />}
                </span>
              </div>
            </div>
            <div className="relative px-10">
              <div
                className="text-6xl font-semibold tracking-tighter uppercase"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                  fontFamily: this.getPrimaryFont(commonSettings),
                }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
              <svg
                className="w-auto h-16 mt-8"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                }}
                viewBox="0 0 167 65"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M167 61.052C167 62.6905 165.138 63.6338 163.817 62.6646L142.183 46.792C141.479 46.2753 140.521 46.2753 139.817 46.792L118.183 62.6646C116.862 63.6338 115 62.6905 115 61.052V2C115 0.89543 115.895 0 117 0H165C166.105 0 167 0.895431 167 2V61.052Z" />
                <path d="M84.0607 34.0607C84.6464 33.4749 84.6464 32.5251 84.0607 31.9393L74.5147 22.3934C73.9289 21.8076 72.9792 21.8076 72.3934 22.3934C71.8076 22.9792 71.8076 23.9289 72.3934 24.5147L80.8787 33L72.3934 41.4853C71.8076 42.0711 71.8076 43.0208 72.3934 43.6066C72.9792 44.1924 73.9289 44.1924 74.5147 43.6066L84.0607 34.0607ZM0 34.5H83V31.5H0V34.5Z" />
              </svg>
            </div>
          </>
        )}
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        {index !== carouselLength - 1 && index !== 0 && (
          <>
            <div className="relative py-10">
              <div
                className="absolute inset-0 flex items-center"
                aria-hidden="true"
              >
                <div
                  className="w-full border-t-4"
                  style={{
                    borderColor: this.getPrimaryColor(commonSettings),
                  }}
                />
              </div>
              <div className="relative flex justify-end">
                <span
                  className="pl-4 pr-10 text-2xl font-semibold"
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                    backgroundColor: this.getBackgroundColor(commonSettings),
                    fontFamily: this.getPrimaryFont(commonSettings),
                  }}
                >
                  {index < 10 ? "0" + index : index}
                </span>
              </div>
            </div>
            <div className="relative px-10">
              <div
                className="text-6xl font-semibold tracking-tighter uppercase"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                  fontFamily: this.getPrimaryFont(commonSettings),
                }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
              <div
                className="mt-5 text-sm font-normal leading-normal"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                  fontFamily: this.getSecondaryFont(commonSettings),
                }}
              >
                {slide.elements[1]?.style ? (
                  <MultilineView
                    element={slide.elements[1]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[1]?.value} />
                )}
              </div>
            </div>
          </>
        )}
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        {index === 0 && (
          <>
            <div className="relative py-10">
              <div
                className="absolute inset-0 flex items-center"
                aria-hidden="true"
              >
                <div
                  className="w-full border-t-4"
                  style={{
                    borderColor: this.getPrimaryColor(commonSettings),
                  }}
                />
              </div>
              <div className="relative flex justify-start">
                <span
                  className="pl-10 pr-4 text-lg font-semibold"
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                    backgroundColor: this.getBackgroundColor(commonSettings),
                    fontFamily: this.getPrimaryFont(commonSettings),
                  }}
                >
                  {<TextView text={commonSettings.elements[2]?.value} />}
                </span>
              </div>
            </div>
            <div className="relative px-10">
              <div
                className="font-semibold tracking-tighter uppercase text-7xl"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                  fontFamily: this.getPrimaryFont(commonSettings),
                }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
            </div>
          </>
        )}
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: commonSettings.elements[3].value.color,
              }}
            ></div>
          )}
        </div>
        <div className="absolute bottom-0 right-0">
          <img className="w-64 h-64 opacity-10" src={StepsPattern} alt="" />
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        <div className="absolute inset-x-0 bottom-0 px-10 pb-8">
          <div className="flex items-end justify-between gap-6">
            {(index === 0 || index === carouselLength - 1) && (
              <div
                className="inline-flex items-center gap-2 text-2xl font-semibold tracking-tight uppercase"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                  fontFamily: this.getPrimaryFont(commonSettings),
                }}
              >
                <img
                  className="w-10 h-10 rounded-full shrink-0"
                  src={commonSettings.elements[1].value.image}
                  alt=""
                />
                <p className="whitespace-nowrap">
                  {<TextView text={commonSettings.elements[0]?.value} />}
                </p>
              </div>
            )}
            {index !== carouselLength - 1 && (
              <div
                className="inline-flex items-center justify-center w-12 h-12  rounded-full"
                style={{
                  backgroundColor: this.getPrimaryColor(commonSettings),
                  color: this.getBackgroundColor(commonSettings),
                }}
              >
                <svg
                  className="w-6 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Basic5;
